import * as React from 'react';

import * as styles from './styles/groupsList.css';
import { SERVICE_TYPE } from '../../../../constants/serviceSubscriptions';
import { IGroup } from '../../../../store';
import { Group } from '../Group';

interface IGroupsListPorps {
  groups: IGroup[];
}

export function GroupsList({ groups }: IGroupsListPorps) {
  return (
    <div className={styles['groups_list']}>
      {groups.map((group, i) => !!group.categories.length && <Group {...group} key={i} />)}
      <Group
        title="Сервисные подписки"
        categoryGroup={SERVICE_TYPE}
        subtitle={
          <div>
            Согласно{' '}
            <a href="/help/about/rules-natural/" target="_blank">
              нашим правилам
            </a>
            , вы не можете отписаться от следующих рассылок: сервисные сообщения о состоянии лицевого счета, обновление
            условий обслуживания, сообщения от пользователей и от модерации.
          </div>
        }
      />
    </div>
  );
}
